import React, { useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Check, Copy } from 'react-feather'
import Flex from '../Flex/Flex'

interface CopyToClipboardButtonProps {
  text: string
  iconColor?: string
}

const MainWrapper = styled(Flex)`
  width: 50px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ text, iconColor }) => {
  const theme = useTheme()

  const [isCopied, setIsCopied] = useState<boolean>(false)

  const handleCopy = () => {
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 3000)
  }

  return (
    <CopyToClipboard text={text} onCopy={() => handleCopy()}>
      <MainWrapper>
        {isCopied ? (
          <Check color={iconColor || theme.colors.purple} size={22} />
        ) : (
          <Copy color={iconColor || theme.colors.purple} size={22} />
        )}
      </MainWrapper>
    </CopyToClipboard>
  )
}

export default CopyToClipboardButton
